import { Observable } from 'rxjs'
import { Node } from '../../models/nodes.model'

export abstract class NodeService {
  abstract getNodes(
    reconDate: string,
    partitionType: string,
    partitionId: number,
  ): Observable<Node[]>

  abstract activate(
    reconDate: string,
    partitionType: string,
    partitionId: number,
    executionIds: number[],
  ): Observable<void>

  abstract inactivate(
    reconDate: string,
    partitionType: string,
    partitionId: number,
    executionIds: number[],
  ): Observable<void>
}
